import { Typography, Box, styled, Table, TableCell, TableRow, TableBody } from '@mui/material';

// Components
import { StyledWhiteBox } from 'src/features/TariffsAndRules/config';
import ExpandableBox from 'src/components/common/ExpandableBox';
import RouterLinkNoUnderline from 'src/components/common/RouterLinkNoUnderline';
import { getArrayDefault } from 'src/utils/helpers/arrayHelpers';
import { formatUrlNonProtocol } from 'src/utils/helpers/stringHelpers';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  borderBottom: 'none',
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  borderBottom: `1px dashed ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper2,
}));

const RegulatoryRequirement = ({ dataNtmMeasure }: { dataNtmMeasure: INtmMeasures }) => {
  return (
    <StyledWhiteBox spacing={3}>
      <Typography variant="h6">
        {dataNtmMeasure.measure_section}{' '}
        <Typography variant="h6" color="primary" component="span">
          ({dataNtmMeasure.measure_total_count})
        </Typography>
      </Typography>
      {getArrayDefault(dataNtmMeasure.measures).map((measure, index) => {
        const listDetailMeasure = dataNtmMeasure.all_measures.filter(
          (measureDetail) => measureDetail.code === measure.measure_code,
        );
        return (
          <ExpandableBox
            key={`${index}-${measure.measure_code}`}
            title={`${measure.measure_code} - ${measure.measure_title} (${measure.measure_count})`}
            openDefault={false}
            flex={1}
            gap={3}
          >
            {getArrayDefault(listDetailMeasure).map((measureDetail, index) => {
              return (
                <Box key={`${index}-${measureDetail.code}`} padding={2} display="flex" flexDirection="column" gap={2}>
                  <Typography variant="subtitle1">
                    {index + 1}/ {measureDetail.title}
                  </Typography>
                  <Table>
                    <TableBody>
                      <StyledTableRow>
                        <StyledTableCell component="th">
                          <Typography variant="subtitle2" color="text.secondary">
                            Legislation Title
                          </Typography>
                        </StyledTableCell>
                        <StyledTableCell>
                          <Typography variant="body2" color="text.secondary">
                            {measureDetail.legislation_title}
                          </Typography>
                        </StyledTableCell>
                      </StyledTableRow>
                      <StyledTableRow>
                        <StyledTableCell component="th">
                          <Typography variant="subtitle2" color="text.secondary">
                            Legislation Summary
                          </Typography>
                        </StyledTableCell>
                        <StyledTableCell>
                          <Typography variant="body2" color="text.secondary">
                            {measureDetail.legislation_summary}
                          </Typography>
                        </StyledTableCell>
                      </StyledTableRow>
                      <StyledTableRow>
                        <StyledTableCell component="th">
                          <Typography variant="subtitle2" color="text.secondary">
                            Implementation Authority
                          </Typography>
                        </StyledTableCell>
                        <StyledTableCell>
                          <Typography variant="body2" color="text.secondary">
                            {measureDetail.implementation_authority}
                          </Typography>
                        </StyledTableCell>
                      </StyledTableRow>
                      <StyledTableRow>
                        <StyledTableCell component="th">
                          <Typography variant="subtitle2" color="text.secondary">
                            Validity
                          </Typography>
                        </StyledTableCell>
                        <StyledTableCell>
                          <Typography variant="body2" color="text.secondary">
                            From {measureDetail.start_date}
                          </Typography>
                        </StyledTableCell>
                      </StyledTableRow>
                      <StyledTableRow>
                        <StyledTableCell component="th">
                          <Typography variant="subtitle2" color="text.secondary">
                            Other Countries Affected
                          </Typography>
                        </StyledTableCell>
                        <StyledTableCell>
                          <Typography variant="body2" color="text.secondary">
                            {measureDetail.additional_comment_country}
                          </Typography>
                        </StyledTableCell>
                      </StyledTableRow>
                      <StyledTableRow>
                        <StyledTableCell component="th">
                          <Typography variant="subtitle2" color="text.secondary">
                            Additional Comments
                          </Typography>
                        </StyledTableCell>
                        <StyledTableCell>
                          <Typography variant="body2" color="text.secondary">
                            {measureDetail.additional_comment_product}
                          </Typography>
                        </StyledTableCell>
                      </StyledTableRow>
                      <StyledTableRow>
                        <StyledTableCell component="th">
                          <Typography variant="subtitle2" color="text.secondary">
                            Link
                          </Typography>
                        </StyledTableCell>
                        <StyledTableCell>
                          <RouterLinkNoUnderline to={formatUrlNonProtocol(measureDetail.web_link)} target="_blank">
                            <Typography variant="body2" color="secondary">
                              URL
                            </Typography>
                          </RouterLinkNoUnderline>
                        </StyledTableCell>
                      </StyledTableRow>
                    </TableBody>
                  </Table>
                </Box>
              );
            })}
          </ExpandableBox>
        );
      })}
    </StyledWhiteBox>
  );
};

export default RegulatoryRequirement;
